import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import React from "react";
import "../i18n";
import "./styles/globals.css";
import TanstackQueryProvider from "./providers/TanstackQueryProvider";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// Tạo QueryClient

// Tạo router
const router = createRouter({ routeTree });

// Đăng ký router
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render app
const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <TanstackQueryProvider>
        <RouterProvider router={router} />
        {/* <ReactQueryDevtools initialIsOpen={true} position="right"/> */}
      </TanstackQueryProvider>
    </StrictMode>
  );
}
